import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

type TAffiliateType = {
  primaryCount: number;
  secondaryCount: number;
  nonAffiliateCount: number;
};

const PieChart = () => {
  const { getApi } = UseApi();
  const [ratio, setRatio] = useState<TAffiliateType>();
  const { primaryCount, secondaryCount, nonAffiliateCount } = ratio || {};

  useEffect(() => {
    const fetchData = async () => {
      const res: any = await getApi(`admin-actions/affiliates-ratio`);
      setRatio(res?.data?.data);
    };
    fetchData();
  }, []);

  const series = [primaryCount, secondaryCount, nonAffiliateCount];
  const chartOptions = {
    id: 'affiliate-pie',
    labels: ['Primary ', 'Secondary ', 'Non-Affiliates'],
  };

  return (
    <div>
      <Header extraClasses="my-4">Affiliates Ratio</Header>
      {ratio && (
        <Chart
          options={chartOptions}
          series={series}
          type="pie"
          className="mx-auto  w-full md:w-5/6  lg:w-3/4"
        />
      )}
    </div>
  );
};

export default PieChart;
